"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElectricityMeterReadingFormLegacy = exports.ids = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../shared/core");
var analytics_subjects_1 = require("../analytics-subjects");
var copy_1 = require("../copy");
var utils_1 = require("../pages/SubmitMeterReading/utils");
var ElecReadingMultiInput_1 = require("./ElecReadingMultiInput");
var ElecReadingSingleInput_1 = require("./ElecReadingSingleInput");
exports.ids = {
    peak: 'meter-reading-peak',
    offpeak: 'meter-reading-offpeak',
    anytime: 'meter-reading-anytime',
    singleDate: 'elec-single-date',
    multiDate: 'elec-multi-date',
};
var ElectricityMeterReadingFormLegacy = function (_a) {
    var _b;
    var currentSupply = _a.currentSupply, isMultiRate = _a.isMultiRate, fuel = _a.fuel, errors = _a.errors, isUpdating = _a.isUpdating, onSubmit = _a.onSubmit;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var _c = (0, core_1.useComponents)(), PrimaryCTAButton = _c.PrimaryCTAButton, Stack = _c.Stack, Notification = _c.Notification;
    var _d = __read((0, react_1.useState)({
        anytime: '',
        peak: '',
        offpeak: '',
    }), 2), meterReading = _d[0], setMeterReading = _d[1];
    var _e = __read((0, react_1.useState)(''), 2), date = _e[0], setDate = _e[1];
    if (!currentSupply.mpxn) {
        return (react_1.default.createElement(Notification, { "data-testid": "no-msn-notification", id: "no-msn" },
            react_1.default.createElement(Copy, { copyKey: "noMsn" })));
    }
    var onMeterReadingChange = function (label) { return function (_a) {
        var _b;
        var _c = _a.currentTarget, meterReadingVal = _c.value, maxLength = _c.maxLength;
        if (maxLength > -1 && meterReadingVal.replace('.', '').length > maxLength) {
            return;
        }
        setMeterReading(__assign(__assign({}, meterReading), (_b = {}, _b[label] = meterReadingVal, _b)));
    }; };
    var handleSubmit = function (event) {
        event.preventDefault();
        var timeOfUseLabels = [
            'peak',
            'offpeak',
            'anytime',
        ];
        var body = {
            readingDateTime: (0, utils_1.getReadingDateTime)(date),
            mpxn: currentSupply.mpxn || '',
            tiers: timeOfUseLabels
                .map(function (timeOfUseLabel) { return ({
                timeOfUseLabel: timeOfUseLabel,
                meterRegisterReading: meterReading[timeOfUseLabel],
            }); })
                .filter(function (tier) { return !!tier.meterRegisterReading; })
                .map(function (tier) { return (__assign(__assign({}, tier), { meterRegisterReading: Number(tier.meterRegisterReading) })); }),
        };
        onSubmit(body);
    };
    var inputs = isMultiRate ? (react_1.default.createElement(ElecReadingMultiInput_1.ElecReadingMultiInput, { ids: exports.ids, errors: errors, meterNumOfDigits: currentSupply.meterNumOfDigits, isUpdating: isUpdating, meterReading: meterReading, onChange: onMeterReadingChange, start: currentSupply.start, setDate: setDate, isOnboarding: currentSupply.isInOMRWindow })) : (react_1.default.createElement(ElecReadingSingleInput_1.ElecReadingSingleInput, { ids: exports.ids, errors: errors, meterNumOfDigits: currentSupply.meterNumOfDigits, isUpdating: isUpdating, meterReading: meterReading, onChange: onMeterReadingChange, start: currentSupply.start, setDate: setDate, isOnboarding: currentSupply.isInOMRWindow }));
    return (react_1.default.createElement("form", { key: fuel, onSubmit: handleSubmit, method: "POST", noValidate: true },
        react_1.default.createElement(Stack, { as: "fieldset", spaceBetween: [4, 8] },
            inputs,
            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.SUBMIT_METER_READING, properties: (_b = {},
                    _b[core_1.INTERNAL_EVENT_FLAG] = true,
                    _b.meterData = (0, utils_1.getMeterReadAnalyticsData)(currentSupply, 'electricity'),
                    _b.backdatedDays = (0, utils_1.getBackdatedDaysToToday)(date),
                    _b.datepickerEntry = date,
                    _b) },
                react_1.default.createElement(PrimaryCTAButton, { type: "submit", "data-testid": "submit-meter-reading", disabled: isUpdating },
                    react_1.default.createElement(Copy, { copyKey: "readingSubmitLabel", values: { fuel: fuel } }))))));
};
exports.ElectricityMeterReadingFormLegacy = ElectricityMeterReadingFormLegacy;
